// @mui
import { ButtonBase, MenuItem, MenuList, Popover } from '@mui/material';
import { menuItemClasses } from '@mui/material/MenuItem';
import { Icon } from '@iconify/react/dist/iconify.js';
import { useNavigate } from 'react-router-dom';
import { useCallback, useState } from 'react';

// utils

// ----------------------------------------------------------------------

const RenderPopOverButton = ({ handleOpenPopover, openPopover, handleClosePopover, onApprove, onDel, onReject, cellProps, setSelectedItem, items, iconName, propsData, deletable, approveable }) => {
    const navigate = useNavigate()
    const [menu, setMenu] = useState(null);
    const openPopoverHandle = useCallback((event) => {
        setMenu(event.currentTarget);
        setSelectedItem && setSelectedItem();
    }, []);
    const closePopover = useCallback(() => {
        setMenu(null);
    }, []);
    return (
        <>
            {
                <>
                    <ButtonBase
                        style={{
                            border: "1.5px solid #D0D0D0",
                            paddingBlock: 3,
                            paddingInline: 7,
                            borderRadius: 5,
                            marginLeft: 5,
                            backgroundColor: 'white',
                            color: '#101010'
                        }}
                        onClick={handleOpenPopover || openPopoverHandle}
                    >
                        <i className={iconName ? iconName : "ri-more-fill"}></i>
                    </ButtonBase>
                    <Popover
                        sx={{
                            "& .MuiPaper-root": {
                                boxShadow: "0 2px 4px rgba(16, 16, 16, 0.08)",
                                borderRadius: "8px"
                            }
                        }}
                        open={!!openPopover || !!menu}
                        anchorEl={openPopover || menu}
                        onClose={handleClosePopover || closePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'left',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'left',
                        }}
                    >
                        <MenuList
                            disablePadding
                            sx={{
                                p: 0.5,
                                gap: 0.5,
                                minWidth: 140,
                                display: 'flex',
                                flexDirection: 'column',
                                [`& .${menuItemClasses.root}`]: {
                                    px: 1,
                                    gap: 2,
                                    borderRadius: 0.75,
                                    [`&.${menuItemClasses.selected}`]: { bgcolor: 'action.selected' },
                                },
                            }}
                        >
                            {
                                items?.length > 0 && items.map((el, idx) => {
                                    return (
                                        el.permission !== false &&
                                        <MenuItem onClick={() => el.onClick()} style={{ color: el?.color || '#000000' }} key={idx}>
                                            {
                                                el?.isNotRemixIcon &&
                                                <Icon icon={el.iconName} fontSize={15} />
                                            }
                                            {
                                                !el?.isNotRemixIcon &&
                                                <i className={`${el.iconName}`} style={{ cursor: "pointer", fontFamily: 'Manrope', fontSize: 14 }} />
                                            }
                                            <span style={{ fontFamily: 'Manrope', fontSize: 14 }}>{el.label}</span>
                                        </MenuItem>
                                    )
                                })
                            }
                            {
                                onDel && deletable &&
                                <MenuItem onClick={onDel} sx={{ color: 'error.main' }}>
                                    <i className="ri-delete-bin-line del-icon" style={{ cursor: "pointer", fontFamily: 'Manrope', fontSize: 14}}> <span style={{ fontFamily: 'Manrope', fontSize: 14, paddingLeft: "5px" }}> Delete</span></i>
                                </MenuItem>

                            }
                        </MenuList>
                    </Popover>
                </>

            }
        </>

    );
}
export default (RenderPopOverButton);
